import { BRAND } from "@/lib/brand";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 pt-24 pb-12">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src={BRAND.logo} alt="Paigez.ai" className="h-20 md:h-24 w-auto" />
            <p className="mt-6 font-display italic text-2xl md:text-3xl text-zinc-200 leading-tight">
              {t.footer.tagline}
            </p>
            <p className="mt-4 text-zinc-500 max-w-md leading-relaxed">
              {t.footer.about}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-zinc-400 mb-5">{t.footer.explore}</p>
            <ul className="space-y-3">
              {t.nav.links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-zinc-300 hover:text-white transition-colors duration-200"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] text-zinc-400 mb-5">{t.footer.contact}</p>
            <ul className="space-y-3 text-zinc-300">
              <li>
                <a href="mailto:Info@paigez.ai" className="hover:text-white transition-colors">
                  Info@paigez.ai
                </a>
              </li>
              <li className="text-zinc-500">{t.footer.enquiries}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} Paigez.ai. {t.footer.rights}
          </p>
          <p className="text-xs text-zinc-500">{t.footer.crafted}</p>
        </div>
      </div>
    </footer>
  );
}
